<template>
  <!-- 弹出框 -->
  <a-modal
    v-model="modal.visible"
    :title="modal.title"
    @ok="handleOk"
    @cancel="cancel"
    :confirm-loading="confirmLoading"
  >
    <a-form-model
      ref="ruleForm"
      :model="formData"
      :rules="rules"
      :label-col="{ span: 4 }"
      :wrapper-col="{ span: 20 }"
    >
      <a-form-model-item label="省份" prop="provinceCode">
        <a-select
          v-model="formData.provinceCode"
          placeholder="请选择省份"
          allow-clear
          @change="handleProvinceChange"
        >
          <a-select-option
            v-for="item in provinceList"
            :value="item.code"
            :key="item.code"
            >{{ item.descript }}({{ item.code }})</a-select-option
          >
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="城市" prop="cityCode">
        <a-select
          v-model="formData.cityCode"
          placeholder="请选择城市"
          allow-clear
        >
          <a-select-option
            v-for="item in tmpCityList"
            :value="item.code"
            :key="item.code"
            >{{ item.descript }}({{ item.code }})</a-select-option
          >
        </a-select>
      </a-form-model-item>

      <a-form-model-item label="区域名称" prop="descript"
        ><a-input v-model="formData.descript" :maxLength="20"
      /></a-form-model-item>
      <a-form-model-item label="区域代码" prop="code"
        ><a-input
          v-model="formData.code"
          :maxLength="20"
          :disabled="modal.type == 'add' ? false : true"
      /></a-form-model-item>
      <a-row>
        <a-col :span="12">
          <a-form-model-item
            label="是否停用"
            :label-col="{ span: 8 }"
            :wrapper-col="{ span: 12 }"
          >
            <a-switch
              checked-children="是"
              un-checked-children="否"
              :checked="formData.isHalt == 'T' ? true : false"
              @change="onChange('isHalt')"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </a-modal>
</template>

<script>
export default {
  name: "DistrictInfo",
  props: {
    provinceList: {
      type: Array,
      default() {
        return [];
      }
    },
    cityList: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      confirmLoading: false,
      tmpCityList: [],
      //弹出框参数
      modal: {
        visible: false,
        title: "",
        type: "add"
      },
      //form
      formData: {
        countryCode: "China",
        provinceCode: "",
        cityCode: "",
        descript: "",
        code: "",
        isHalt: "F"
      },
      //form rules
      rules: {
        provinceCode: [
          {
            required: true,
            message: "请输选择省份",
            trigger: "change"
          }
        ],
        cityCode: [
          {
            required: true,
            message: "请输选择城市",
            trigger: "change"
          }
        ],
        code: [
          {
            required: true,
            message: "请输入区域代码",
            trigger: "change"
          }
        ],
        descript: [
          {
            required: true,
            message: "请输入区域名称",
            trigger: "change"
          }
        ]
      }
    };
  },
  created() {},
  methods: {
    showModal(type, data) {
      this.modal.visible = true;
      this.modal.title = type == "add" ? "添加区域" : "编辑区域";
      this.modal.type = type;
      if (data) {
        this.formData = Object.assign({}, data);
        this.handleProvinceChange(this.formData.provinceCode);
      }
    },
    handleProvinceChange(value) {
      for (let p of this.provinceList) {
        if (p.code == value) {
          this.formData.countryCode = p.countryCode;
          break;
        }
      }
      let arr = [];
      for (let city of this.cityList) {
        if (city.provinceCode == value) {
          arr.push(city);
        }
      }
      this.tmpCityList = arr;
    },
    onChange(column) {
      if (this.formData[column] == "T") {
        this.formData[column] = "F";
      } else {
        this.formData[column] = "T";
      }
    },
    cancel() {
      this.formData = {};
      this.confirmLoading = false;
      this.$refs.ruleForm.resetFields();
      this.modal.visible = false;
    },
    /**
     * 保存
     */
    handleOk() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let param = Object.assign({}, this.formData);
          this.confirmLoading = true;
          let action = "saveCodeDistrict";
          if (this.modal.type == "edit") {
            action = "modifyCodeDistrict";
          }
          this.$http.systemBksApi[action](param)
            .then(res => {
              if (res.result == 0) {
                this.cancel();
                this.$emit("success");
                this.$message.success(res.msg);
              }
            })
            .finally(() => {
              this.confirmLoading = false;
            });
        }
      });
    }
  }
};
</script>

<style></style>
